var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#471700",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 189.5V273h-27.9v-83.5H256zm76.5 0V273h-27.9v-83.5h27.9zm0 146.1l48.7-48.8V133.9H151.6v201.7h62.7v41.7l41.7-41.7h76.5zM409.1 106v194.8l-83.5 83.5h-62.7L221.2 426h-41.7v-41.7H103V161.6l21-55.6h285.1z",
    fill: "#FFF"
  })));
}

export default SvgTwitch;